import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" viewBox="-7 -5 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7,2.6C5.4,3,3.8,4.4,3.3,5.9L3.2,6.3v26.1v26.1L3.4,59c0.4,1.4,1.8,2.7,3.4,3.2c0.2,0.1,0.4,0.1,0.5,0.2
	c0.2,0.1,32.5,0.1,32.6,0c0,0,0.2-0.1,0.4-0.1c1.3-0.3,2.8-1.5,3.4-2.6c0.5-1,0.4,1.5,0.4-27.2v-26l-0.2-0.6c-0.4-1.3-1.3-2.3-2.7-3
	c-1.1-0.5,0.4-0.5-17.6-0.5C8.1,2.5,7.4,2.5,7,2.6z M30.4,6.1c0,0.5,0,12.8,0,27.3v26.3H19.5c-6.2,0-10.9,0-11-0.1
	c-0.1,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.7-0.3-1-0.4c-0.7-0.4-0.9-0.6-1.1-1.4l-0.2-0.5V32.6c0-27,0-24.9,0.4-25.8
	c0.3-0.6,0.4-0.7,1.1-1c1.2-0.6,0.1-0.6,12.3-0.6h10.8L30.4,6.1z M38.7,5.3c0.5,0.1,1.2,0.4,1.6,0.7c0.4,0.2,0.6,0.7,0.8,1.4
	l0.1,0.5v24.7v24.7L41,57.7c-0.3,0.7-0.5,1-1.2,1.3c-0.3,0.2-0.8,0.4-1,0.4c-0.2,0.1-0.5,0.1-0.5,0.2c-0.1,0-0.2,0.1-0.3,0.1h-0.2
	V32.5V5.2h0.1C38.2,5.2,38.5,5.2,38.7,5.3z"
        fill={colourFill}
      />
      <path
        d="M19.6,9.9c-0.5,0.1-0.6,0.2-1.8,2.3c-0.5,0.9-1.1,2-1.5,2.5c-0.3,0.5-0.7,1.2-0.8,1.4C15,17,14.6,17.8,13.8,19
	c-0.4,0.7-0.9,1.6-1.2,2.1c-0.2,0.4-0.6,1.1-0.9,1.5c-0.8,1.3-1.1,2-1.1,2.3c0,0.4,0.2,0.7,0.7,1c0.1,0.1,2,0.1,8.4,0.1
	c9.2,0,8.5,0,8.9-0.5c0.2-0.2,0.2-0.3,0.2-0.8c0-0.4,0-0.5-0.1-0.7c-0.2-0.2-1-1.6-1-1.7v-0.1c0,0-0.2-0.2-0.3-0.5
	c-0.2-0.4-1-1.9-1.9-3.4c-0.6-1.1-1.3-2.4-1.7-3c-0.4-0.7-2-3.6-2.5-4.4c-0.5-0.9-0.6-1-1-1.1C20,9.8,19.9,9.8,19.6,9.9z"
        fill={colourFill}
      />
      <path
        d="M27.1,36.9c-0.5-0.9-1.8-1.3-4.8-1.6c-1-0.1-3.9-0.1-5,0c-1.8,0.1-3.3,0.4-3.9,0.8c-0.4,0.2-0.8,0.7-0.9,1
	c-0.1,0.2-0.1,1.7-0.1,5.8v5.5l0.2,0.3c0.2,0.4,0.6,0.6,1,0.7l0.3,0.1v0.4c0,0.7,0.1,0.7,1.5,0.7c1.4,0,1.4,0,1.5-0.7v-0.4h3h2.9
	v0.4c0,0.3,0,0.4,0.1,0.5l0.1,0.2h1.2c1.4,0,1.4,0,1.4-0.7v-0.4h0.3c0.5-0.1,1-0.4,1.2-0.9c0.1-0.2,0.1-0.8,0.1-5.8v-5.6L27.1,36.9z
	 M18.4,36.8c0-0.2,0-0.4,0-0.4s0.6,0,1.4,0c1.1,0,1.4,0,1.4,0.1s0.1,0.2,0.1,0.4v0.3h-1.4h-1.4L18.4,36.8L18.4,36.8z M16.2,46.9
	C16.1,47,16,47,15.2,47C14,47,14,47,14,46.1c0-0.7,0-0.8,0.3-0.8c0.1,0,0.5,0.1,1,0.2c0.5,0.1,0.9,0.3,1,0.3
	C16.4,46.1,16.4,46.8,16.2,46.9z M19.8,44H14v-2.7c0-1.5,0-2.8,0-2.8c0-0.1,1.2-0.1,5.8-0.1c3.2,0,5.8,0,5.8,0.1
	c0.1,0,0.1,0.7,0.1,2.8v2.8L19.8,44L19.8,44z M24.6,47c-0.9,0-0.9,0-1.1-0.2c-0.1-0.1-0.2-0.2-0.2-0.5c0-0.5,0.1-0.6,1-0.8
	c0.9-0.3,1.1-0.3,1.3-0.1c0.1,0.1,0.1,0.2,0.1,0.7C25.8,47,25.7,47,24.6,47z"
        fill={colourFill}
      />
    </svg>
  );
};

export default ServiceIcon;
